// Chore: cleanup, for demo purpose only
import { IColor } from 'src/app/types';

export const mockColors: IColor[] = [
  {
    name: 'Red',
    code: 'ff0000',
  },
  {
    name: 'Green',
    code: '00ff00',
  },
  {
    name: 'Blue',
    code: '0000ff',
  },
  {
    name: 'Cyan',
    code: '00ffff',
  },
  {
    name: 'Magenta',
    code: 'ff00ff',
  },
  {
    name: 'Yellow',
    code: 'ffff00',
  },
  {
    name: 'Black',
    code: '000000',
  },
];
